import { motion } from "framer-motion";

interface Props {
  visible?: boolean;
  children: React.ReactNode;
}

export const FadeInAndOut = (props: Props) => {
  const isVisible = props.visible || true;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{
        opacity: isVisible ? 1 : 0,
      }}
      transition={{ opacity: { duration: 0.3 } }}
      style={{ width: "100%" }}
    >
      {props.children}
    </motion.div>
  );
};
